export default __webpack_public_path__ + "static/media/supertcm_logo_with_name.35cf76b3.png";